<template>
  <div class="home">
    <div class="right-header fw700">
      <div class="red time-style">
        <img src="@/assets/images/编组 8@2x copy 2.png" alt="" class="icon-box mr10">
        <span class="little-title">24H快讯</span>
      </div>
      <GsMore class="blue-text" @click="moreClick">更多新闻</GsMore>
    </div>
    <GsSkeleton v-if="loading" :rows="6" />
    <div class="right-content" v-else>
      <div class="right-item" v-for="(item, i) in twentyFourNewList" :key="i" @click="openNewDetail(item)">
        <div class="item-side">
          <span class="item-date">{{ formatTime(item.createTime) }}</span>
          <span class="item-dot" :class="{ hot: i < 3 }"></span>
          <img v-if="i < 3" src="@/assets/images/编组 54@2x.png" class="icon-huo"/>
        </div>
        <div class="item-title-row">
          <div class="item-title"><span v-if="String(item.whetherTop)==='1'" class="is-top-badge">置顶</span>{{ item.chineseTitle }}</div>
          <span class="item-tag tag-two" v-if="item.rangeTypeName && item.rangeTypeName[0]">{{ item.rangeTypeName[0] }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getNewsList,
} from "@/api/api";
import { P } from '@/router/paths'
export default {
  props: {
    /** 预览场景：直接传入要渲染的记录，传了就不请求接口 */
    items: { type: Array, default: null },
  },
  data() {
    return {
      loading: true,
      twentyFourNewList:[],
      prodUrl:"https://shujuzichan.com/xwzx",
    };
  },
  created() {
    if (Array.isArray(this.items) && this.items.length) {
      this.twentyFourNewList = this.items.map((item) => {
        if (item.rangeTypeName && typeof item.rangeTypeName === 'string') {
          return { ...item, rangeTypeName: item.rangeTypeName.split(',') }
        }
        return item
      })
      this.loading = false
      return
    }
    this.gettwentyFourNewList();
  },
  methods: {
    formatTime(value) {
      const text = String(value || '')
      const hit = text.match(/(\d{1,2}:\d{2})(?::\d{2})?/)
      if (hit) return hit[1]
      return text ? text.slice(-5) : '--:--'
    },
    gettwentyFourNewList() {
      var formData = {};
      formData["pageNum"]=1;
      formData["pageSize"]=10;
      formData["type"]=1;
      formData["whetherPublish"]='1';
      getNewsList(formData).then((response) => {
        this.twentyFourNewList = response.rows || [];
        if(this.twentyFourNewList) {
          this.twentyFourNewList = this.twentyFourNewList.map(item => {
            if(item.rangeTypeName) {
              item.rangeTypeName = item.rangeTypeName.split(',')
            }
            return item
          })
        }
      }).finally(() => {
        this.loading = false
      });
    },
    openNewDetail(item) {
      this.$router.push(P.newsDetail(item.id))
    },
    moreClick() {
      // 资讯页已按类型分 tab，24H快报对应 type=1
      this.$router.push({ path: P.news, query: { type: '1' } })
    }
  }
};
</script>

<style scoped>
.right-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 5px;
}
.icon-box {
  width: 40px;
  height: 40px;
}
.item-detail {
  width: 50px;
  height: 20px;
  font-family: AlibabaPuHuiTi_3_55_Regular;
  font-size: 14px;
  color: #0165FF;
  line-height: 20px;
  text-align: right;
  font-style: normal;
  text-decoration-line: underline;
}
.item-detail:hover {
  color: #d2232a;
}
.item-tag{
  width: auto;
  min-width: 50px;
  padding: 0 6px;
  text-align: center;
  font-family: AlibabaPuHuiTi_3_65_Medium;
  font-size: 10px;
  color: #0165FF;
  line-height: 16px;
  font-style: normal;
  height: 16px;
  border-radius: 4px;
  border: 1px solid #0165FF;
  flex-shrink: 0;
}
.tag-two {
  background: #0165FF;
  color: #FFFFFF;
}
.icon-huo {
  width: 18px;
  height: 20px;
  flex-shrink: 0;
}
.little-title {
  height: 33px;
  font-family: AlibabaPuHuiTi_3_65_Medium;
  font-size: 24px;
  color: #111824;
  line-height: 33px;
  text-align: left;
  font-style: normal;
}
.more-text {
  /* display: flex; */
  /* width: 60px; */
  height: 32px;
  font-family: AlibabaPuHuiTi_3_55_Regular;
  font-size: 15px;
  color: #111824;
  line-height: 32px;
  text-align: left;
  font-style: normal;
}
.time-style {
  display: flex;
  align-items:center;
  float: left;
}
.more {
  float: right;
  margin-right: 10px;
}
.more:hover {
  color:red;
}
.right-content {
  padding: 0 10px;
  height: 360px;
  overflow: auto;
}
.item-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex: 1;
  min-width: 0;
}
.item-title {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-family: AlibabaPuHuiTi_3_55_Regular;
  font-weight: 500;
  font-size: 14px;
  color: #404753;
  line-height: 20px;
  text-align: left;
}
.item-title:hover {
  color: #0165FF;
}
.item-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.detail-box img {
  width: 100%;
  height: 150px;
  border-radius: 6px 6px 0 0;
} 

.right-content {
  color-scheme: light dark;
  scrollbar-width: thin;
  scrollbar-color: auto;
}
.right-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 2px;
  cursor: pointer;
  background: transparent;
  box-shadow: none;
  transition: transform 0.2s ease;
}
.right-item:hover {
  transform: translateY(-2px);
  box-shadow: none;
  background: transparent;
}
.item-side {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
  max-width: 58%;
}
.item-date {
  flex: 0 0 auto;
  font-variant-numeric: tabular-nums;
  font-family: AlibabaPuHuiTi_3_55_Regular;
  font-size: 13px;
  color: #404753;
  line-height: 20px;
}
.item-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #c5ced9;
  flex: 0 0 auto;
}
.item-dot.hot {
  background: #d2232a;
  box-shadow: 0 0 0 2px rgba(210, 35, 42, 0.18);
}

.item-card {
  display: flex;
  justify-content: flex-end;
}
@media (max-width: 960px) {
  .right-content {
    height: auto;
    max-height: 240px;
  }
  .right-header {
    margin-bottom: 4px;
  }
  .little-title {
    font-size: 14px;
    height: auto;
    line-height: 20px;
  }
  .item-side {
    max-width: 42%;
  }
  .item-date {
    font-size: 11px;
  }
  .item-title {
    font-size: 12px;
    line-height: 1.3;
  }
  .right-item {
    padding: 5px 0;
  }
  .item-tag {
    font-size: 10px;
  }
}

.is-top-badge { display:inline-block; margin-right:4px; padding:0 4px; font-size:12px; color:#fff; background:#D9001B; border-radius:3px; }
</style>